import config from '../../../temp/config';

window.certAppConfig = config;
